<template>
    <div class="RegistrationList mx-auto my-2">
        <Nav></Nav>
        <div id="loading" v-if="showLoading">
            <img
            class="loadingImg"
            src="../../assets/images/loading.gif"
            alt="loading..."
            width="200"
            />
        </div>
        <div class="list" v-for="item in RegistrationListData">
            <span class="ListNo">No.{{item.registrationId}}</span>
            <br>
            <!-- 學校 -->
            <div class="d-flex">
                <span class="subtitle">學　　校：</span>
                <span class="data">{{item.school}}</span>
            </div>
            <!-- 課程 -->
            <div class="d-flex">
                <span class="subtitle">課　　程：</span>
                <span class="data">{{item.course}}</span>
            </div>
            <!-- 周數 -->
            <div class="d-flex">
                <span class="subtitle">周　　數：</span>
                <span class="data">{{item.week}}weeks {{item.startDate}} 至 {{item.endData}}</span>
            </div>
            <!-- 住宿 -->
            <div class="d-flex">
                <span class="subtitle">住　　宿：</span>
                <span class="data">{{item.room}}</span>
            </div>
            <!-- 接機地 -->
            <div class="d-flex">
                <span class="subtitle">接機地點：</span>
                <span class="data">{{item.pick}}</span>
            </div>
            <!-- 狀態 -->
            <div class="d-flex">
                <span class="subtitle">狀　　態：</span>
                <span class="data">{{item.state}}</span>
            </div>
        </div>
        
    </div>
</template>

<script>
import Nav from '@/components/Nav'
import {app} from '@/main'
import Vue from 'vue'
import axios from 'axios'

export default {
    name: 'RegistrationList',
    components:{
        Nav,
    },
    data () {
        return {
            showLoading:'',

            RegistrationListData:[],
            // RegistrationListData:[{
            //     registrationId:'103978-001',
            //     school:"CIA(Mactan)", //學校
            //     week:1, //週數
            //     room:"Twin Room", //住宿
            //     course:"Regular ESL", //課程
            //     pick:"CEBU", //接機地
            //     startDate:"2023-02-26", //周數起始日
            //     endData:"2023-03-04", //周數結束日
            //     state:"已報名",
            // },{
            //     registrationId:'103978-001',
            //     school:"CIA(Mactan)", //學校
            //     week:1, //週數
            //     room:"Twin Room", //住宿
            //     course:"Regular ESL", //課程
            //     pick:"CEBU", //接機地
            //     startDate:"2023-02-26", //周數起始日
            //     endData:"2023-03-04", //周數結束日
            //     state:"已報名",
            // }]
        }
    },
    methods:{
        GetRegistrationList(){
            this.showLoading = true;
            const api =`${process.env.APIPATH}/api/Registration/GetRegistrationList`;
            const inputdata = 
            {
                "deweyUserId":this.DeweyUserId,
            };

            axios.post(api, inputdata)
                .then((response) => {
                    this.showLoading = false;
                    if(response.data.isSuccess){ 
                        this.RegistrationListData = response.data.registrationListData
                    }else{
                        console.error("There was an error!", response.data.message);
                    }
                })
                .catch(error => {
                    this.showLoading = false;
                    this.errorMessage = error.message;
                    console.error("There was an error!", error);
                });
        },
    },
    created(){
        this.DeweyUserId=JSON.parse(sessionStorage.getItem('UserData')).deweyUserId;
        this.GetRegistrationList();
    },
}
</script>




// WEBPACK FOOTER //
// src/components/line/RegistrationList.vue